import { Injectable } from '@angular/core';
import { ApiService } from '@app/services/api/api.service';
import {
  AutocompleteActionTypes,
  AutocompleteActionsUnion,
  Load,
  LoadFail,
  LoadSingle,
  LoadSingleFail,
  LoadSingleSuccess,
  LoadCollections,
  LoadCollectionsSuccess,
  LoadTags
} from '@core/actions/autocomplete.actions';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, concatMap, map, tap, switchMap } from 'rxjs/operators';

const routes = [
  'products/metadata.tripDate',
  'products/countryType',
  'products/businessUnit',
  'products/season',
  'products/metadata.quality',
  'products/articleGroupName',
  'products/metadata.productType',
  'products/metadata.collection',
  'products/tags',
];

@Injectable()
export class AutocompleteEffects {
  @Effect()
  load$: Observable<Action> = this.actions$.pipe(
    ofType<Load>(AutocompleteActionTypes.Load),
    concatMap(() => routes.map(route => new LoadSingle(route))),
    catchError(error => of(new LoadFail(error)))
  );

  @Effect()
  loadCollections$: Observable<Action> = this.actions$.pipe(
    ofType<LoadCollections>(AutocompleteActionTypes.LoadCollections),
    map(action => action.FollowId),
    switchMap(FollowId =>
      this.api.getProductCollectionsByFollow(FollowId).pipe(
        map(result => new LoadSingleSuccess(result, 'products/metadata.collection')),
        catchError(error => of(new LoadSingleFail(error)))
      )
    )
  );

  @Effect()
  loadTags$: Observable<Action> = this.actions$.pipe(
    ofType<LoadTags>(AutocompleteActionTypes.LoadTags),
    map(action => action.FollowId),
    switchMap(FollowId =>
      this.api.getProductTagsByFollow(FollowId).pipe(
        map(result => new LoadSingleSuccess(result, 'products/tags')),
        catchError(error => of(new LoadSingleFail(error)))
      )
    )
  );
  // @Effect()
  // loadSingle$: Observable<Action> = this.actions$.pipe(
  //   ofType<LoadSingle>(AutocompleteActionTypes.LoadSingle),
  //   map(action => action.route),
  //   concatMap(route =>
  //     this.api.getAutocompleteByRoute(route, FollowId: ).pipe(
  //       concatMap(result => {
  //         return [new LoadSingleSuccess(result, route)];
  //       }),
  //       catchError(error => of(new LoadSingleFail(error)))
  //     )
  //   )
  // );

  constructor(private actions$: Actions, private api: ApiService) {}
}
